module.exports = __webpack_public_path__ + "static/img/img_0588.1d2ee0e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/portfolio/img_0588.jpg
// module id = TIAt
// module chunks = 0